import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getTrcInstruction, getTrcCaption } from '../../../troConstants';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { narrateScreen, playPlaylist } from '../../../trcActions';
import { trackPauseDemoVideo, trackRestartDemoVideo } from '../../../trcReporting';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { narrateReset, stopAudio } from '../../../../common/audio/audioActions';
import TRODemoVideoContainer from '../../demoVideos/TRODemoVideoContainer';
import selectors from '../../../../rootSelectors';
import { setOwlyCanSpeak } from '../../../../common/avatar/avatarActions';

const instructionsKey = 'demoVideoStart';

const mapDispatchToProps = dispatch => ({
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const instruction = getTrcInstruction(
            isExternalURLSourcePresent,
            instructionsKey,
            arLanguage,
        );
        const caption = getTrcCaption(isExternalURLSourcePresent, instructionsKey, arLanguage);
        return dispatch(narrateScreen(instruction, caption));
    },
    playPlaylist: playlistIndex => dispatch(playPlaylist(playlistIndex)),
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
    },
    setOwlyCanSpeak: toSet => dispatch(setOwlyCanSpeak(toSet)),
    trackPauseDemoVideo: () => dispatch(trackPauseDemoVideo()),
    trackRestartDemoVideo: () => dispatch(trackRestartDemoVideo()),
});

const mapStateToProps = state => ({
    activeVideoId: selectors.getTRCActiveDemoVideoId(state),
    demoVideosProgress: selectors.getTRCDemoVideosProgress(state),
    areAllDemoVideosWatched: selectors.areAllDemoVideosWatched(state),
    nextIncompletePlaylistItem: selectors.getNextIncompleteMeasure(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    arLanguage: selectors.getArLanguage(state),
});

const avatarMapStateToProps = state => ({
    instructions: getTrcInstruction(
        selectors.getExternalURLSourceStatus(state),
        instructionsKey,
        selectors.getArLanguage(state),
    ),
    position: AvatarView.Position.MIDDLE_LEFT,
});

export default withRouter(
    compose(
        connect(mapStateToProps, mapDispatchToProps),
        withAvatar(avatarMapStateToProps),
    )(TRODemoVideoContainer),
);
